// test2272
(2272 && 0);
